export const GET_ALL_PRODUCTS = 'GET_ALL_PRODUCTS'
export const GET_ALL_OFFERS = 'GET_ALL_OFFERS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_SINGLE_PROJECT = 'GET_SINGLE_PROJECT'
export const GET_SINGLE_PROJECT_TIMES = 'GET_SINGLE_PROJECT_TIMES'
export const GET_SINGLE_PROJECT_LABEL = 'GET_SINGLE_PROJECT_LABEL'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const CLEAR_RESPONSE_EDIT = 'CLEAR_RESPONSE_EDIT'
export const GET_ALL_ACTIVE_AUCTIONS = 'GET_ALL_ACTIVE_AUCTIONS'
export const GET_ALL_BID_HISTORY = 'GET_ALL_BID_HISTORY'
export const GET_ALL_PROXY_HISTORY = 'GET_ALL_PROXY_HISTORY'
export const GET_ALL_API_LOGS = 'GET_ALL_API_LOGS'
export const GET_ALL_TTWBID_HISTORY = 'GET_ALL_TTWBID_HISTORY'
export const RECONCILIATION = 'GET_RECONCILIATION_DATA'
export const GET_SYNC_DASHBOARD_DATA = 'GET_SYNC_DASHBOARD_DATA'
export const GET_ALL_ROYALTY_INPUTS = 'GET_ALL_ROYALTY_INPUTS'
export const GET_ALL_PROJECT_ACCESS = 'GET_ALL_PROJECT_ACCESS'
export const GET_EDIT_ACTION_STATUS = 'GET_EDIT_ACTION_STATUS'
export const GET_SINGLE_INVENTORY = 'GET_SINGLE_INVENTORY'
